module.exports = __webpack_public_path__ + "static/media/less.11cca26c.svg";